
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Kerstin',

    metaInfo: { title: 'Kerstin Bergström' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'kerstin-bilder',
        'kerstin-videos',
        'kerstin-cv',
        'kerstin-social',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'kerstin',
      },
    },
  }
</script>
